@let vm = vm$ | async;

@if (vm) {
  <div
    class="pu-balances"
    [class.pu-balances_card]="isCard()"
  >
    @if (isCard()) {
      <div class="pu-balances__cards ">
        <swiper
          class="pu-balances__slider"
          [config]="sliderConfig"
        >
          @for (balance of vm.balances; track balance.balanceType) {
            <pu-balance-card
              *swiperSlide
              [balance]="balance"
              (click)="openHistory(balance.balanceType)"
            >
              @switch (balance.balanceType) {
                @case ('regular') {
                  <button
                    class="lg:pu-button_s xl:pu-button_m"
                    type="button"
                    puButton
                    uiType="secondary"
                    size="m"
                    (click)="share(); $event.stopPropagation()"
                    [title]="'balances.button.shareCoins' | translate"
                    translate="balances.button.share"
                  >
                  </button>

                  <a
                    class="lg:pu-button_s xl:pu-button_m"
                    type="button"
                    puButton
                    uiType="secondary"
                    size="m"
                    routerLink="/quests"
                    [title]="'balances.button.earnCoins' | translate"
                    (click)="$event.stopPropagation()"
                    translate="balances.button.earn"
                  >
                  </a>
                }
                @case ('functional') {
                  <button
                    class="lg:pu-button_s xl:pu-button_m"
                    puButton
                    type="button"
                    uiType="secondary"
                    size="m"
                    (click)="openTeamBonuses(); $event.stopPropagation()"
                    translate="balances.button.sendBonus"
                  >
                  </button>
                }
              }
            </pu-balance-card>
          }
        </swiper>

        <pu-slider-controls
          class="pu-balances__slider-controls"
          [hasButtons]="uiStore.isDesktop()"
          prevControlClass="pu-balances__slider-controls_prev"
          nextControlClass="pu-balances__slider-controls_next"
        />

        <div class="swiper-pagination"></div>
      </div>

      <a
        puButton
        uiType="quaternary"
        routerLink="/faq{{getCoinsCategoryFaqPath(vm)}}"
        translate="balances.link.howToEarnCoins"
      >
      </a>
    } @else {
      @if (uiStore.isTabletAndMore()) {
        <div class="pu-balances__actions">
          <button
            type="button"
            puButton
            uiType="primary"
            size="l"
            (click)="share()"
            [title]="'balances.button.shareCoins' | translate"
            translate="balances.button.share"
          >
          </button>

          <a
            type="button"
            puButton
            uiType="primary"
            size="l"
            routerLink="/quests"
            [title]="'balances.button.earnCoins' | translate"
            translate="balances.button.earn"
          >
          </a>

          <a
            puButton
            uiType="secondary"
            size="l"
            routerLink="/faq{{getCoinsCategoryFaqPath(vm)}}"
            translate="balances.link.howToEarn"
          >
          </a>
        </div>
      }

      <p class="pu-balances__balance">
        <pu-icon
          iconName="coins"
          size="20"
        />

        <span
          class="pu-balances__balance-sum"
          [attr.translate]="'no'"
        >
          {{ vm.userBalance?.amount }}
        </span>

        <pt-coin />
      </p>
    }
  </div>
}
